export default __webpack_public_path__ + "static/media/ZamZam.aad360b9.png";